import type { ClientItemId } from 'owa-client-ids';
import {
    isLoaded,
    initializeAllLoadedAccounts,
    CalendarEndpointType,
} from 'owa-calendar-cache-loader';
import type { TraceErrorObject } from 'owa-trace';
import type { LockedCalendarEventsStore } from 'owa-calendar-events-store';

const hasPendingFetch = new Map<string, boolean>();

export default async function fetchCalendarEventAndSubscribe(
    itemId: ClientItemId,
    onNotFoundError: () => void,
    store: LockedCalendarEventsStore
) {
    if (!hasPendingFetch.get(itemId.Id)) {
        hasPendingFetch.set(itemId.Id, true);

        try {
            if (!isLoaded(CalendarEndpointType.Outlook)) {
                await initializeAllLoadedAccounts();
            }

            const { fullEventPromise } = store.fetchFullCalendarEvent(
                itemId,
                undefined /** folderId */,
                undefined /**getExistingCalendarEvent */,
                undefined /** isfetchFullSeriesMasterCalendarEventFromEventInstance */,
                { fetchSource: 'TimeStream' }
            );

            const fullEvent = await fullEventPromise;
            store.subscribeNotifications(fullEvent.ParentFolderId.Id);
        } catch (err) {
            if ((err as TraceErrorObject)?.diagnosticInfo?.indexOf('ErrorItemNotFound') != -1) {
                onNotFoundError();
            }
        } finally {
            hasPendingFetch.delete(itemId.Id);
        }
    }
}
